import { render, staticRenderFns } from "./companyPolicies.vue?vue&type=template&id=1eb816a4&scoped=true"
import script from "./companyPolicies.vue?vue&type=script&lang=js"
export * from "./companyPolicies.vue?vue&type=script&lang=js"
import style0 from "./companyPolicies.vue?vue&type=style&index=0&id=1eb816a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb816a4",
  null
  
)

export default component.exports